import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { AutocompleteProperty } from '../enums';
import { NO_OPTIONS_MESSAGE } from '../constants';

const AutocompleteProps = {
  props: {
    [AutocompleteProperty.Id]: {
      default: '',
      type: String,
    },
    [AutocompleteProperty.Value]: {
      default: '',
      type: String,
    },
    [AutocompleteProperty.Label]: {
      default: '',
      type: String,
    },
    [AutocompleteProperty.Placeholder]: {
      default: '',
      type: String,
    },
    [AutocompleteProperty.ColorScheme]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [AutocompleteProperty.LabelColorScheme]: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    [AutocompleteProperty.IconColor]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [AutocompleteProperty.ErrorMessage]: {
      default: '',
      type: String,
    },
    [AutocompleteProperty.HideOnContentClick]: {
      default: false,
      type: Boolean,
    },
    [AutocompleteProperty.Options]: {
      default: () => [],
      type: Array,
    },
    [AutocompleteProperty.IsLoading]: {
      default: false,
      type: Boolean,
    },
    [AutocompleteProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [AutocompleteProperty.IsShowErrorMessage]: {
      default: false,
      type: Boolean,
    },
    [AutocompleteProperty.NoOptionsMessage]: {
      default: NO_OPTIONS_MESSAGE,
      type: String,
    },
  },
};

export default AutocompleteProps;
